import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { COMMAND_PRIORITY_HIGH, KEY_ENTER_COMMAND } from 'lexical'
import { nanoid } from 'nanoid'
import { useEffect } from 'react'
import { getCurrentNode } from '@/features/screenplay/components/editor/utils/NodeUtils'
import { ParaNode } from '../nodes/ParaNode'

const StEnterPlugin = () => {
    const [editor] = useLexicalComposerContext()
    useEffect(() => {
        return editor.registerCommand(
            KEY_ENTER_COMMAND,
            (event) => {
                event?.preventDefault()
                editor.update(() => {
                    const currentNode = getCurrentNode()
                    if (!currentNode) return

                    const newParagraph = ParaNode.create(nanoid())
                    newParagraph.select()
                    currentNode.insertAfter(newParagraph)
                })
                return true
            },
            COMMAND_PRIORITY_HIGH
        )
    }, [editor])
    return null
}

export default StEnterPlugin
